/**
 * Homey Admin V2 API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IgnoredReason } from './ignored-reason';
import { NycProfileStatus } from './nyc-profile-status';


export interface UserRegistrationDto { 
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    createdAt: string;
    /**
     * Kept because the registration search matches on it. The Housing Connect password and the NYC mailbox addresses are deliberately NOT part of this DTO: this endpoint returns a whole page of users at a time, and nothing renders those fields. They were only ever needed by admin-api\'s \"Auto-register\" button, which handed credentials to a browser extension and no longer exists. Credentials are available one user at a time from the user detail endpoint.
     */
    nycUsername: string;
    nycProfileStatus: NycProfileStatus;
    lastSyncStatus: string;
    loginStatus: string;
    ignore: boolean;
    ignoredReason: IgnoredReason;
    syncFailedCount: number;
    loginFailedCount: number;
    lastSyncError?: string;
    autoCreateStatus: UserRegistrationDto.AutoCreateStatusEnum;
    autoCreateFailureReason?: string;
}
export namespace UserRegistrationDto {
    export const AutoCreateStatusEnum = {
        pending: 'pending',
        in_progress: 'in-progress',
        failed: 'failed'
    } as const;
    export type AutoCreateStatusEnum = typeof AutoCreateStatusEnum[keyof typeof AutoCreateStatusEnum];
}


